export default {
  no_results: {
    title: 'Ingen resultater for „{{search}}“',
    desc: 'Vi kunne desværre ikke finde et match. Prøv et andet søgeord.',
  },
  empty_menu: {
    title: 'Ingen varer tilgængelige endnu',
    desc: 'Denne menu har ikke noget at vise lige nu. Kig forbi igen snart.',
  },
};
